<template>
  <div class="informatives-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header
      :title="`${informativeId ? 'Editar' : 'Cadastrar'} Notícia`"
    >
      <button
        type="button"
        v-app-button.clear.icon-left
        v-app-back-button="{ name: 'informatives.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <informatives-form
        @submit="onSubmit"
        :id="informativeId"
        :errors="errors"
        :saving="isSaving"
      ></informatives-form>
    </app-card>
  </div>
</template>

<script>
import InformativesService from '@/services/informative.service';
import InformativesForm from '@/components/Forms/InformativesForm.vue';

export default {
  name: 'informatives-form-page',
  components: {
    InformativesForm,
  },
  data: () => {
    return {
      informativeId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(informative) {
      this.informativeId && this.update(this.informativeId, informative);
      !this.informativeId && this.save(informative);
    },
    save(informative) {
      this.isSaving = true;
      InformativesService.save(informative)
        .then(() => {
          this.toastify('Notícia cadastrada com sucesso!');
          this.$router.push({ name: 'informatives.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Notícia.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, informative) {
      this.isSaving = true;
      InformativesService.update(id, informative)
        .then(() => {
          this.toastify('Notícia atualizada com sucesso!');
          this.$router.push({ name: 'informatives.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Notícia.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.informativeId = this.$route.params.id;
  },
};
</script>
